import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { motion } from 'framer-motion'
import React, { forwardRef, useEffect, useRef, useState } from 'react'
import { useMedia } from 'react-use'
import styled from 'styled-components'
import { SearchEmpty } from './SearchEmpty'
import { SearchNoResults } from './SearchNoResults'
import { SearchResults } from './SearchResults'
import { useAlgoliaSearchContext } from './controllers/AlgoliaSearchContext'

const ResultsContainer = styled(motion.div)`
  overflow-y: auto;
`

export const SearchContent = forwardRef((_props, ref) => {
  const contentRef = useRef<HTMLDivElement | null>(null)
  const [contentRefVisible, setContentRefVisible] = useState(false)
  const { isModalOpen, isEmpty, isResultsReturned, isNoResults } = useAlgoliaSearchContext()
  const isMobile = useMedia('(max-width: 576px)')

  useEffect(() => {
    if (contentRefVisible && contentRef.current && isMobile) {
      if (open) {
        disableBodyScroll(contentRef.current)
      } else {
        enableBodyScroll(contentRef.current)
      }
    }

    return () => {
      clearAllBodyScrollLocks()
    }
  }, [isModalOpen, contentRefVisible, isMobile])

  return (
    <ResultsContainer
      ref={(el) => {
        contentRef.current = el
        setContentRefVisible(!!el)
      }}>
      {isEmpty && <SearchEmpty />}
      {isResultsReturned && <SearchResults />}
      {isNoResults && <SearchNoResults />}
    </ResultsContainer>
  )
})

SearchContent.displayName = 'SearchContent'
